import React from 'react';
import { Navigate } from 'react-router-dom';

// Lazy load components
const Payments = React.lazy(() => import('../pages/Payments/Payments'));
const NewPayment = React.lazy(() => import('../pages/Payments/NewPayment'));
const PaymentDetail = React.lazy(() => import('../pages/Payments/PaymentDetail'));
const RecurringPayments = React.lazy(() => import('../pages/Payments/RecurringPayments/RecurringPayments'));
const RecurringPaymentDetail = React.lazy(() => import('../pages/Payments/RecurringPayments/RecurringPaymentDetail'));
const PaymentLinkPage = React.lazy(() => import('../pages/Payments/PaymentLink'));

export const getPaymentRoutes = (loggedIn, visibleTabs, location, loginRedirect) => [
  {
    path: '/paymentslist',
    element: (loggedIn && visibleTabs?.includes('Payments'))
      ? <Payments />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />,
    children: [
      {
        path: 'new-payment',
        element: (loggedIn && visibleTabs?.includes('Payments'))
          ? <NewPayment />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'payment-details',
        element: (loggedIn && visibleTabs?.includes('Payments'))
          ? <PaymentDetail />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      }
    ]
  },
  {
    path: '/rec-payments-list',
    element: (loggedIn && visibleTabs?.includes('RecurringPayment'))
      ? <RecurringPayments />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />,
    children: [
      {
        path: 'new-payment',
        element: (loggedIn && visibleTabs?.includes('RecurringPayment'))
          ? <NewPayment />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'payment-details',
        element: (loggedIn && visibleTabs?.includes('RecurringPayment'))
          ? <RecurringPaymentDetail />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      }
    ]
  },
  {
    path: '/payments-online/:organization/:subdomain',
    element: <PaymentLinkPage />
  }
];

